import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { denormalize } from 'denormalizr';

import SnippetEditor from './SnippetEditor';
import emailSnippet from '../../schemas/emailSnippet';
import { loadSchedulingEmailSnippet, saveSchedulingEmailSnippet } from '../../actions/schedulingEmailSnippets';

class SchedulingSnippetEditor extends React.Component {
  static propTypes = {
    snippetId: PropTypes.string
  };

  static defaultProps = {type: ''};

  constructor(props) {
    super(props);

    /**
     * state
     * @type {object}
     * @property {boolean} showModal show or hide the editor modal
     */
    this.state = {
      showModal: true,
      snippet: {}
    };
  }

  render() {
    const {calendar, dispatch} = this.props;

    function handleSubmit(snippet) {
      delete(snippet.tokens);

      return dispatch(saveSchedulingEmailSnippet(calendar, snippet));
    }

    return this.state.showModal && <SnippetEditor
      fields={[
        {
          displayName: 'Default reply to',
          canonicalName: 'reply_to',
          tooltip: 'Separate multiple email addresses with commas',
        },
        {
          displayName: 'Default CC',
          canonicalName: 'cc_emails',
          tooltip: 'Separate multiple email addresses with commas',
          optional: true
        },
        {
          displayName: 'Default BCC',
          canonicalName: 'bcc_emails',
          tooltip: 'Separate multiple email addresses with commas',
          optional: true
        },
        {
          displayName: 'Subject',
          canonicalName: 'subject'
        }
      ]}
      handleSubmit={(item) => handleSubmit(item)}
      item={this.state.snippet}
      onClose={() => this.close()}
      type={this.props.type}
    />
  }

  close() {
    this.setState({showModal: false});
  }

  componentDidMount() {
    const {calendar, dispatch, snippet} = this.props;

    dispatch(loadSchedulingEmailSnippet(calendar, snippet)).then((response) => {
      let loadedSnippet = denormalize(response.result.scheduling_email_snippet, response.entities, emailSnippet);

      this.setState({snippet: loadedSnippet});
    });
  }
}

export default connect()(SchedulingSnippetEditor);
